// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"7fab32c98bd286588d66","293":"601e276da7133a32a180","454":"f62dcf131390294413ce"}[chunkId] + ".js";
};